import type { EditorAPI } from '#packages/editorAPI';
import constants from '#packages/constants';
import type { ImageDetails, ImagesMap } from '@wix/editor-site-generator';
import { files } from '@wix/santa-editor-utils';

export const getMetaSiteInstance = (editorAPI: EditorAPI): string =>
  editorAPI.platform.getAppDataByApplicationId(
    constants.APPLICATIONS.META_SITE_APPLICATION_ID,
  ).instance;

export const uploadImage = async (
  msInstance: string,
  compId: string,
  imageDetails: ImageDetails,
  aiImages: ImagesMap,
) => {
  try {
    const { url } = await files.uploadSiteFileUsingExternalUrl(msInstance, {
      url: imageDetails.localUri,
      name: imageDetails.displayName,
    });

    aiImages.get(compId).staticUri = url;
  } catch (error) {
    console.error(`Failed to upload image for component ${compId}:`, error);
  }
};
